import { useRESTv1, extendURLParams } from "@/utils/fetchData";
export const useInternetServiceProvider = (opts) => useRESTv1(`/internet/provider`, extendURLParams(), opts);
